import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import FeatureCard from "../Cards/FeatureCard"
import "./index.scss"
import VideoModal from "../VideoModal"
import { Link } from "gatsby"

export default function FeaturedContentHero({ component }) {
  const { background, headline, featuredContent } = component
  const featureCard = featuredContent[0]

  const featureLink = featuredContent[0].button[0].linkUrl

  //----- Video Modal States and Handlers
  const [modalOpen, setModalOpen] = useState(false)
  const [videoCode, setVideoCode] = useState("")
  const [vidSource, setVidSource] = useState("")

  const handleModal = e => {
    e.target.getAttribute("data-hasvid") === "true" && setModalOpen(true)
    setVideoCode(e.target.getAttribute("data-vidlink"))
    setVidSource(e.target.getAttribute("data-vidsource"))
  }
  return (
    <>
      {modalOpen && (
        <VideoModal
          open={modalOpen}
          vidSource={vidSource}
          videoCode={videoCode}
          setModalOpen={setModalOpen}
        />
      )}
      <div
        data-datocms-noindex
        className="featured-content-hero"
        style={{
          backgroundColor: `${
            background[0].backgroundColor && background[0].backgroundColor
          }`,
        }}
      >
        {background[0].hasBackgroundImage && (
          <GatsbyImage
            image={getImage(background[0].image)}
            className="bg-image"
            alt=""
          />
        )}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="oblique text-white">{headline}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10">
              <div className="feature-card-wrapper">
                <Link to={featureLink}>
                  <FeatureCard
                    featureData={featureCard}
                    handleModal={handleModal}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
